import { useEffect, useState } from "react";
import { fetchCarModels, fetchTopNModels } from "../../services/api";

import "./ModelSelection.scss";

const ModelSelection = (props)=>{
    const url = new URL(window.location);
    const params = url.searchParams;
    const [model, setModel] = useState();

    useEffect(()=>{
        if(model){
            props.modelSelected(model);
        }
    },[model])

    const proceedToNext = (model)=>{
        setModel(model);
    }

    return (<>
        <div className="model-selection-wrapper">
            <div className="model-selection-header">Select a Car Model of {props.make}</div>
            <div className="model-selection-sub-header">All the models are of a year 2021</div>
            {
                props.topNModels.length > 0 &&
                <>
                    <div className="model-selection-list-label">Popular Models</div>
                    <ul className="model-selection-list">
                        {
                            props.topNModels.map(_=>{
                                return (
                                    <li key={_.value} onClick={()=>{
                                        proceedToNext(_.name);
                                        window.dataLayer?.push({
                                            'event': 'Selected model'
                                        })
                                    }}>
                                        <div>{_.name}</div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    <div className="model-selection-list-label">All Models</div>
                </>
            }
            <ul className="model-selection-list">
                {
                    props.modelOptions.map(_=>{
                        return (
                            <li key={_.value} onClick={()=>{
                                proceedToNext(_.name);
                                window.dataLayer?.push({
                                    'event': 'Selected model'
                                })
                            }}>
                                <div>{_.name}</div>
                            </li>
                        )
                    })
                }
                
            </ul>
        </div>
    </>)
}

export default ModelSelection